import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export function useList<T>(key: string, path: string) {
  const { token } = useAuth();
  return useQuery({ queryKey: [key], queryFn: () => apiFetch<{ items: T[] }>(path, { token }), enabled: !!token });
}

export function useCreate<TBody>(path: string, invalidate: string[]) {
  const { token } = useAuth(); const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: TBody) => apiFetch(path, { method: "POST", body: JSON.stringify(body), token }),
    onSuccess: () => invalidate.forEach((k) => qc.invalidateQueries({ queryKey: [k] })),
  });
}

export function useUpdate<TBody>(pathOf: (id: string) => string, invalidate: string[]) {
  const { token } = useAuth(); const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: TBody }) =>
      apiFetch(pathOf(id), { method: "PUT", body: JSON.stringify(body), token }),
    onSuccess: () => invalidate.forEach((k) => qc.invalidateQueries({ queryKey: [k] })),
  });
}

export const money = (c?: number) =>
  c == null ? "—" : `$${(c / 100).toLocaleString(undefined, { minimumFractionDigits: 0 })}`;
